import { isLanguageCode } from './i18n-resources/language-utils';
import { defaultLanguage, type LanguageCode } from './i18n-resources/languages';

export function createLocalizedPath(lang: LanguageCode, path: string, addEnglishPath: boolean = false): string {
    const wemodWebsiteUrl = process.env.NEXT_PUBLIC_WEMOD_WEBSITE_URL;

    // Check if this is a WeMod website URL that needs localization
    if (wemodWebsiteUrl && path.startsWith(wemodWebsiteUrl)) {
        try {
            const url = new URL(path);
            const pathname = url.pathname;

            const pathSegments = pathname.startsWith('/') ? pathname.substring(1).split('/') : pathname.split('/');

            if (isLanguageCode(pathSegments[0])) {
                return path;
            }

            if (lang === defaultLanguage && !addEnglishPath) {
                return path;
            }

            const localizedPathname = `/${lang}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
            url.pathname = localizedPathname;

            return url.toString();
        } catch {
            // If URL parsing fails, continue with normal logic
        }
    }

    try {
        // Will succeed only for absolute URLs
        new URL(path);
        return path; // It's external, leave as-is
    } catch {
        // Not an absolute URL – continue
    }

    // Relative paths: do not localize
    if (path.startsWith('./') || path.startsWith('../')) {
        return path;
    }

    // Check if path already has a language prefix to avoid double localization
    const pathSegments = path.startsWith('/') ? path.substring(1).split('/') : path.split('/');

    if (isLanguageCode(pathSegments[0]) || (lang === defaultLanguage && !addEnglishPath)) {
        return path; // Already localized or default language, return as-is
    }

    // The locale root is `/de`, not `/de/`: the trailing-slash form 301-redirects.
    if (path === '/' || path.startsWith('/#') || path.startsWith('/?')) {
        return `/${lang}${path.substring(1)}`;
    }

    // Prefix root-relative paths
    return `/${lang}${path.startsWith('/') || path.startsWith('#') || path.startsWith('?') ? path : `/${path}`}`;
}
